var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-menu-links"},_vm._l((_vm.info),function(item,index){return _c('div',{key:index,staticClass:"items"},[_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }